export default __webpack_public_path__ + "static/media/master_b_95_cel.c1d0eb28.jpg";